import { isUndefined as isUndefined_lodash } from 'lodash';
import { Point, Rectangle } from '../objects/index';

// TODO: Group functions by capability (colors, math, etc)

/**
 * Rounds `value` to the nearest decimal. Borrowed from MDN (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round).
 * Returns NaN if the input is not a number.
 * @param {Number} value - the value to round
 * @param {Number} exp - the number of decimals to round to
 * @returns {Number}
 */
export const roundToDecimals = (value, exp = 3) => {
  value = Number(value);
  exp = Number(exp);

  if (isNaN(value) || isNaN(exp)) {
    return NaN;
  }

  value = value.toString().split('e');
  value = Math.round(Number(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

  value = value.toString().split('e');
  return Number(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
};

/**
 * Inserts a value at the specified index
 * @param array
 * @param index
 * @param value
 * @returns {*|Array.<T>}
 */
export const insertAt = (array, index, value) => {
  return array.splice(index, 0, value);
};

/**
 * Removes a chunk of elements from an array
 * @param array
 * @param start (integer) Start index
 * @param end (integer) End index. If not supplied only the single element will be removed
 * @returns {*}
 */
export const removeChunk = (array, start, end) => {
  var rest = array.slice((end || start) + 1 || array.length);
  array.length = (start < 0) ? array.length + start : start;
  return array.push.apply(array, rest);
};

/**
 * Sets the first num elements of the array starting from offset and ending the specified num elements later to the
 * specified value
 * @param array (Array) The array to fill
 * @param offset (Number) The starting index
 * @param length (Number) The number of elements to fill
 * @param value (*) Value to be set
 */
export const memset = function (array, offset, length, value) {
  for (var i = 0; i < length; i++) {
    array[offset++] = value;
  }
};

/**
 * creates and updates a circular buffer of the specified length for numeric values and maintains the sum and average
 * value of the buffer.
 *   Note that the average value will be skewed low until the buffer has been filled.
 *   Note that numerical values are assumed to be in the buffer.
 * @param length
 * @returns {{get: get, push: push, getSum: getSum, getLength: getLength, getAvg: getAvg, getAvgInt: getAvgInt, toString: toString, reset: reset}}
 */
export function circBuffer (length) {
  var pointer = 0;
  var buffer = new Array(length);
  var sum = 0;
  for (var i = 0; i < length; i++) {
    buffer[i] = 0;
  }
  return {
    get: function (key) {
      return buffer[key];
    },
    push: function (item) {
      var nextPtr = (length + pointer + 1) % length;
      sum -= buffer[nextPtr];
      sum += item;
      buffer[pointer] = item;
      pointer = nextPtr;
    },
    getSum: function () {
      return sum;
    },
    getLength: function () {
      return length;
    },
    getAvg: function () {
      return sum / length;
    },
    getAvgInt: function () {
      return parseInt(sum / length, 10);
    },
    toString: function () {
      for (var rtnStr = buffer[0], i = 1; i < length; i++) { rtnStr += ', ' + buffer[i]; }
      return rtnStr;
    },
    reset: function () {
      pointer = 0;
      sum = 0;
      for (var i = 0; i < length; i++) {
        buffer[i] = 0;
      }
    }
  };
}

/**
 * in an array of json objects, find index where array[idx][key] == value
 * @param array
 * @param key
 * @param value
 * @returns {number}
 */
export function getIndexWith (array, key, value) {
  if (!array) {
    return -1;
  }

  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] && array[i][key] == value) {
      return i;
    }
  }

  return -1;
}

// This function is predominantly used for debugging purposes. TODO: Exterminate!
export function toStringAssoc (assocArray, opt_delimiter, opt_dontReport) {
  var str = '';
  var delimiter = (opt_delimiter == undefined) ? ', ' : opt_delimiter + ' ';

  for (var key in assocArray) {
    if (assocArray.hasOwnProperty(key)) {
      if (opt_dontReport && opt_dontReport[key] != undefined) { continue; }
      if (str.length != 0) str += delimiter;
      str += key + ': ' + assocArray[key];
    }
  }
  return str;
}

/**
 * Returns the "length" of a JavaScript object, where the length is interpreted of the number of keys in the object.
 * @param assocArray
 * @returns {Number}
 */
export function assocArrayLength (assocArray) {
  return Object.keys(assocArray).length;
}

/**
 *
 * @param object
 * @returns {*}
 */
// TODO: Review this logic. It appears to check if object is "number-like", not actually if it's a number.
export function isNumber (object) {
  return !isNaN(parseFloat(object)) && isFinite(object);
}

// left in for compatibility with legacy. TODO: Replace with lodash.
export const isUnDefined = isUndefined_lodash;

// Wow, really? TODO: Remove.
export function isDefined (variable) {
  return variable !== undefined;
}

/**
 * This function returns the passed imageId without a leading '@' sign
 * @param imageId
 * @returns {string|*}
 */
export function stripLeadingAtSign (imageId) {
  return (imageId.indexOf && imageId.indexOf('@') === 0) ? imageId.substr(1) : imageId;
}

/**
 * This function converts a hex color value (e.g. "#FFFFFF") to decimal RGB
 * @param hexColor
 * @returns {*}
 */
export function hexColortoRGB (hexColor) {
  var rtnColor = hexColor;
  if (typeof (hexColor) === 'string' && hexColor.indexOf('#') === 0) {
    rtnColor = parseInt(hexColor.substr(1), 16);
  }
  return rtnColor;
}

/**
 * This function converts a decimal RGB value to hex
 * @param decRGB
 * @returns {number}
 */
export function toHexColor (decRGB) {
  let red = (decRGB >> 16) & 0xFF;
  let green = (decRGB >> 8) & 0xFF;
  let blue = (decRGB & 0xFF);

  red = red.toString(16);
  green = green.toString(16);
  blue = blue.toString(16);

  if (red.length < 2) red = '0' + red;
  if (green.length < 2) green = '0' + green;
  if (blue.length < 2) blue = '0' + blue;

  return (red + green + blue);
}

/**
 * This function returns a decimal BGR ordered color from a decimal RGB ordered color or visa versa!
 * @param decRGB
 * @returns {number}
 */
export function reverseCLR (decRGB) {
  var blue = (decRGB & 0xFF);
  var green = (decRGB >> 8) & 0xFF;
  var red = (decRGB >> 16) & 0xFF;

  return (blue << 16) + (green << 8) + red;
}

/**
 * This function returns the component colors of a hex-encoded string (e.g. 0xfe0422)
 * @param rgbColor
 * @returns {number[]}
 */
export function getComponentColors (rgbColor) {
  const blue = (rgbColor & 0xFF);
  const green = (rgbColor >> 8) & 0xFF;
  const red = (rgbColor >> 16) & 0xFF;
  return [red, green, blue];
}

/**
 * This function returns true if the input color is light, otherwise it returns false. Determines brightness of color by
 * converting to the Y component of YUV, which is brightness.
 * @param color
 * @returns {boolean}
 */
export function isLightColor (color) {
  color = hexColortoRGB(color); // if input is hex format, convert it
  const [red, green, blue] = getComponentColors(color);
  //    don't need U and V, but fyi, they are:      U = 0.436 * (blue - Y) / (1 / 0.114);  V = 0.615 * (red - Y) / (1 / 0.299);
  var Y = parseInt((red * 0.299) + (green * 0.587) + (blue * 0.114), 10);
  return (Y > 139);
}

/**
 * This function rounds a float value to the nearest decimal as determined by the number of decimals
 * @param value
 * @param decplace
 * @returns {Number}
 */
export function roundToNearset (value, decplace) {
  return (Math.round(value * decplace) / decplace);
}

/**
 * This function returns the value if it is inclusively within the min/max Value boundaries;
 * @param value
 * @param minValue
 * @param maxValue
 * @returns {number} returns the minValue if it is less than the minValue; returns the maxValue if it is greater than
 * the maxValue
 */
export function limitValue (value, minValue, maxValue) {
  return Math.min(Math.max(minValue, value), maxValue);
}

/**
 * This function returns an array of the classes associated with the passed element or undefined if the element had no class.
 * @param element
 * @returns {*}
 */
export function getClassList (element) {
  const classes = element.getAttribute('class');

  if (classes) { return classes.split(' '); }

  return undefined;
}

/**
 * This function creates an n dimensional array.
 * @param length
 * @returns {Array}
 */
function arrayNDCreate (length) {
  var a = new Array(length || 0);
  var i;
  if (a.dims == undefined) {
    a.dims = new Array(arguments.length);
    for (i = 0; i < arguments.length; i++) { a.dims[i] = arguments[i]; }
  }

  if (arguments.length > 1) {
    var args = Array.prototype.slice.call(arguments, 1);
    for (i = 0; i < length; i++) {
      a[i] = arrayNDCreate.apply(this, args);
    }
  }
  return a;
}

// -------------------------------------------------------------------------------------------------
// array2DCreate - This function wraps arrayNDCreate and adds the width and height properties to the array.
export function array2DCreate (width, height) {
  var a = arrayNDCreate(width, height);

  a.width = a.dims[0];
  a.height = a.dims[1];
  return a;
}

// -------------------------------------------------------------------------------------------------
//    divRotate -
//
//    Depends upon:
//        Rectangle object
//
//    Note that the DIV position must be absolute or relative
//    Reference: http://stackoverflow.com/questions/2449668/how-to-rotate-a-div-html-layer
//

/**
 * This function rotates a div about its center and returns a rect of its position offset.
 * @param divObj
 * @param divLeft
 * @param divTop
 * @param divWidth
 * @param divHeight
 * @param angleRad
 * @returns {Rectangle}
 */
export function divRotate (divObj, divLeft, divTop, divWidth, divHeight, angleRad) {
  var isNotIE = (window.navigator.userAgent.indexOf('MSIE ') <= 0 || typeof document.documentElement.style.opacity !== 'undefined');
  var radAngle = angleRad;
  var spinAngle = radAngle;

  if (window.navigator.userAgent.indexOf('MSIE ') <= 0 || typeof document.documentElement.style.opacity !== 'undefined') { radAngle = -radAngle; }

  var sinAngle = parseFloat(parseFloat(Math.sin(radAngle)).toFixed(8));
  var cosAngle = parseFloat(parseFloat(Math.cos(radAngle)).toFixed(8));

  var m11 = cosAngle;
  var m12 = -sinAngle;
  var m21 = sinAngle;
  var m22 = cosAngle;

  if (isNotIE == true) {
    divObj.style.WebkitTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
    divObj.style.MozTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + 'px,' + 0 + 'px)';
    divObj.style.msTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
    divObj.style.OTransform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';
    divObj.style.transform = 'matrix(' + m11 + ',' + m12 + ',' + m21 + ',' + m22 + ',' + 0 + ',' + 0 + ')';

    divObj.style.top = divTop + 'px';
    divObj.style.left = divLeft + 'px';
  }
  var sinSpinAngle = -parseFloat(parseFloat(Math.sin(-spinAngle)).toFixed(8));
  var cosSpinAngle = parseFloat(parseFloat(Math.cos(-spinAngle)).toFixed(8));
  var sinAnglePerp = parseFloat(parseFloat(Math.sin(radAngle - Math.PI)).toFixed(8));
  var cosAnglePerp = parseFloat(parseFloat(Math.cos(radAngle - Math.PI)).toFixed(8));
  var halfHeight = divHeight / 2;
  var halfWidth = divWidth / 2;
  var radius = Math.sqrt(halfHeight * halfHeight + halfWidth * halfWidth);

  var ulx = divLeft + halfWidth - radius * cosSpinAngle + sinAnglePerp * halfHeight;
  var uly = divTop + halfHeight - radius * sinSpinAngle + cosAnglePerp * halfHeight;

  var urx = radius * cosSpinAngle + divLeft + halfWidth + sinAnglePerp * halfHeight;
  var ury = radius * sinSpinAngle + divTop + halfHeight + cosAnglePerp * halfHeight;

  var lrx = radius * cosSpinAngle + divLeft + halfWidth - sinAnglePerp * halfHeight;
  var lry = radius * sinSpinAngle + divTop + halfHeight - cosAnglePerp * halfHeight;

  var llx = divLeft + halfWidth - radius * cosSpinAngle - sinAnglePerp * halfHeight;
  var lly = divTop + halfHeight - radius * sinSpinAngle - cosAnglePerp * halfHeight;

  if (isNotIE == false) { divObj.style.filter = 'filter: progid:DXImageTransform.Microsoft.Matrix( M11=' + m11 + ', M12=' + m12 + ', M21=' + m21 + ', M22=' + m22 + ', sizingMethod=\'auto expand\' );'; }

  var spinTop = Math.min(uly, ury, lry, lly);
  var spinRight = Math.max(ulx, urx, lrx, llx);
  var spinBottom = Math.max(uly, ury, lry, lly);
  var spinLeft = Math.min(ulx, urx, lrx, llx);

  if (isNotIE == false) {
    divObj.style.top = spinTop + 'px';
    divObj.style.right = spinRight + 'px';
    divObj.style.bottom = spinBottom + 'px';
    divObj.style.left = spinLeft + 'px';
  }
  return new Rectangle(spinLeft.toFixed(2), spinTop.toFixed(2), (spinRight - spinLeft).toFixed(2), (spinBottom - spinTop).toFixed(2));
}

export function computeRotationOffset (divW, divH, angleRad) {
  var cpRtn = new Point(0, 0); // return point object
  if (angleRad != 0) {
    if (angleRad > Math.PI) { angleRad = angleRad - Math.PI; }

    var xc = divW / 2;
    var yc = divH / 2;

    // compute y offset.....................................
    var x = 0;
    var y = 0; // use top left corner
    var dx = (angleRad <= Math.PI / 2) ? x - xc : xc - x;
    var dy = yc - y;
    var hypot = Math.sqrt(dx * dx + dy * dy);

    var thetaRad = Math.atan2(dy, dx);
    var phiRad = (thetaRad - angleRad);
    cpRtn.y = hypot * Math.sin(phiRad);

    var yi = yc - cpRtn.y;
    cpRtn.y = Math.round(yi);
    if (cpRtn.y >= divH) { cpRtn.y = divH - cpRtn.y; }

    // compute x offset.....................................
    x = 0;
    y = divH; // use bottom left corner
    dx = (angleRad <= Math.PI / 2) ? x - xc : xc - x;
    dy = yc - y;
    hypot = Math.sqrt(dx * dx + dy * dy);

    thetaRad = Math.atan2(dy, dx);
    phiRad = (thetaRad - angleRad);
    cpRtn.x = hypot * Math.cos(phiRad);

    var xi = cpRtn.x + xc;
    cpRtn.x = Math.round(xi);
    if (cpRtn.x >= divW) { cpRtn.x = divW - cpRtn.x; }
  }
  return cpRtn;
}

// -------------------------------------------------------------------------------------------------
// MISCELLANEOUS FUNCTIONS
// -------------------------------------------------------------------------------------------------
// getImageIdFromSrcAttr - This function returns the image id encoded into the passed event's src attribute
//            or undefined if it is not found. The returned image id has the @ sign prepended to it.
export function getImageIdFromSrcAttr (event) {
  var id;
  var srcAttr = $(event).attr('src'); // source attribute e.g. "/@2?0+0+122+122+-2"
  var at = srcAttr.lastIndexOf('@');
  var q = srcAttr.indexOf('?');
  if (at !== -1 && q !== -1) { id = srcAttr.slice(at, q); }
  return id;
}

/**
 * Downloads a file from the specified uri or blob.
 * @param uri
 * @param blob
 * @param filename
 */
export function download ({uri = null, blob = null, filename = null}) {
  const link = document.createElement('a');

  // Chrome, FF, Edge support adding a 'download' attribute which makes a hyperlink downloadable.
  if (uri && typeof link.download === 'string') {
    link.href = uri;

    if (filename) {
      link.download = filename;
    }

    // This is stupid but Firefox requires the link to be in the body for the click() call to work.
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Microsoft pushed a download API in IE before the download attribute was standardized, so fallback to that if we can.
  } else if (blob && window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(blob, filename);
    // If all else fails just open a new window.
  } else {
    window.open(uri);
  }
}

/**
 * Dataserver (or imageserver, it's hard to tell where) don't accept the standard uri-encoded
 * attribute values provided by functions such as encodeUriComponent() or _.escape(), so we
 * just divine our own encoding mechanism. In particular, "&" and "%" characters seem to be
 * troublesome.
 * @param val
 * @returns {*}
 */
export function escapeDataServerAttributeValue (val) {
  return val.replace(/&/g, '_amp;')
    .replace(/%/g, '_lt;')
    .replace(/</g, '_lt;')
    .replace(/>/g, '_gt;')
    .replace(/"/g, '_quot;')
    .replace(/'/g, '_apos;');
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/utility/helpers.js